import Svg, { Mask, Path } from '@rd-core-svg/svg'
import type { FlagsSvgProps } from '../svg.types'

export const BancoDoBrasilSmall = (props: FlagsSvgProps) => {
  return (
    <Svg width={36} height={24} viewBox="0 0 36 24" fill="none" {...props}>
      <Mask id="path-1-inside-1_22078_4096" fill="white">
        <Path d="M0 4C0 1.79086 1.79086 0 4 0H32C34.2091 0 36 1.79086 36 4V20C36 22.2091 34.2091 24 32 24H4C1.79086 24 0 22.2091 0 20V4Z" />
      </Mask>
      <Path
        d="M0 4C0 1.79086 1.79086 0 4 0H32C34.2091 0 36 1.79086 36 4V20C36 22.2091 34.2091 24 32 24H4C1.79086 24 0 22.2091 0 20V4Z"
        fill="#FDE100"
      />
      <Path
        d="M4 0V1H32V0V-1H4V0ZM36 4H35V20H36H37V4H36ZM32 24V23H4V24V25H32V24ZM0 20H1V4H0H-1V20H0ZM4 24V23C2.34315 23 1 21.6569 1 20H0H-1C-1 22.7614 1.23858 25 4 25V24ZM36 20H35C35 21.6569 33.6569 23 32 23V24V25C34.7614 25 37 22.7614 37 20H36ZM32 0V1C33.6569 1 35 2.34315 35 4H36H37C37 1.23858 34.7614 -1 32 -1V0ZM4 0V-1C1.23858 -1 -1 1.23858 -1 4H0H1C1 2.34315 2.34315 1 4 1V0Z"
        fill="#E6E6E6"
        mask="url(#path-1-inside-1_22078_4096)"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 9.33336L13.3302 11.5556L17.3302 8.88892L15.6651 7.77468L17.831 6.33493L22.4945 9.44603L14.8326 14.554L16.4977 15.6682L26 9.33336L18 4L10 9.33336ZM26 14.6667L22.6636 12.4445L18.6635 15.1111L20.3286 16.2191L18.1628 17.6651L13.4992 14.554L21.1612 9.44603L19.4961 8.3318L10 14.6667L18 20L26 14.6667ZM26 6.22222L24.3286 7.33649L22.6636 6.22222L26 4V6.22222ZM10 17.7778L11.6651 16.6635L13.3302 17.7778L10 20V17.7778Z"
        fill="#003882"
      />
    </Svg>
  )
}
